<template>
  <div>
    <LoaderApp v-if="loading"></LoaderApp>
    <div v-else>
      <div class="card">
        <div class="no-gutters row">
          <div class="col-12">
            <div class="widget-content" style="border-bottom: 1px solid rgba(0,0,0,0.125);">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Artículo:</h4>
                </div>
                <div class="widget-content-left">
                  <h4 class="m-0 widget-heading text-secondary">{{articulo.descripcion}} ({{articulo.codigo}})</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Precio venta:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-success m-0 widget-heading">${{articulo.precio_venta}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Precio compra:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading text-alternate">${{articulo.precio_compra}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Stock actual:</p>
                </div>
                <div class="widget-content-left">
                  <p :class="((articulo.stock <= articulo.stock_minimo) ? 'text-danger' : '') + ' m-0 widget-heading '">{{articulo.stock}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Stock mínimo:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{articulo.stock_minimo}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">IVA:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{articulo.iva.descripcion}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Marca:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{articulo.marca.descripcion}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Familia:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{articulo.familia.descripcion}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">
          <h5 class="m-0">Historial de stock</h5>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Operación</th>
                  <th class="text-right">Stock anterior</th>
                  <th class="text-center"></th>
                  <th class="text-left">Stock nuevo</th>
                  <th class="text-right">Precio anterior</th>
                  <th class="text-center"></th>
                  <th class="text-left">Precio nuevo</th>
                  <th>Observaciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingActividad">
                  <td colspan="10" class="text-center py-3">Cargando historial...</td>
                </tr>
                <tr v-else-if="actividades.length === 0">
                  <td colspan="10" class="text-center py-3">No hay movimientos registrados</td>
                </tr>
                <tr v-for="act in actividades" :key="act.id">
                  <td>{{ act.created_at | moment("DD/MM/YYYY HH:mm") }}</td>
                  <td>{{ act.user ? act.user.nombre : '-' }}</td>
                  <td>
                    <span class="badge" :class="badgeClass(act)">{{ act.contexto }}</span>
                  </td>
                  <td class="text-right">{{ act.stock_anterior }}</td>
                  <td class="text-center">
                    <span v-if="act.stock_nuevo > act.stock_anterior" class="text-success font-weight-bold">&uarr;</span>
                    <span v-else-if="act.stock_nuevo < act.stock_anterior" class="text-danger font-weight-bold">&darr;</span>
                    <span v-else class="text-muted">=</span>
                  </td>
                  <td class="text-left">{{ act.stock_nuevo }}</td>
                  <td class="text-right">${{ parseFloat(act.precio_anterior).toFixed(2) }}</td>
                  <td class="text-center">
                    <span v-if="act.precio_nuevo != act.precio_anterior" class="text-warning font-weight-bold">&ne;</span>
                    <span v-else class="text-muted">=</span>
                  </td>
                  <td class="text-left">${{ parseFloat(act.precio_nuevo).toFixed(2) }}</td>
                  <td>{{ act.observaciones || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="actividadPaginacion && actividadPaginacion.last_page > 1" class="d-flex justify-content-center py-2">
            <button class="btn btn-sm btn-outline-secondary mr-2" :disabled="actividadPaginacion.current_page <= 1" @click="getActividad(actividadPaginacion.current_page - 1)">Anterior</button>
            <span class="align-self-center">Página {{ actividadPaginacion.current_page }} de {{ actividadPaginacion.last_page }}</span>
            <button class="btn btn-sm btn-outline-secondary ml-2" :disabled="actividadPaginacion.current_page >= actividadPaginacion.last_page" @click="getActividad(actividadPaginacion.current_page + 1)">Siguiente</button>
          </div>
        </div>
      </div>
      <div class="card p-2 mt-2">
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-info btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >Volver</button>
          </div>
          <div class="col-md-2 offset-md-6">
            <router-link
              class="btn btn-block btn-warning text-white mb-2 mb-md-0"
              :to="{name:'EditarArticulo', params:{id:articulo.id}}"
            >Editar</router-link>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-danger btn-block mb-2 mb-md-0"
              type="button"
              @click="eliminarArticulo()"
            >Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Articulo from "@/models/articulo";
import Swal from "sweetalert2";
import axios from "axios";
import LoaderApp from "@/components/loaders/LoaderApp";
export default {
  name: "VerCliente",
  components: {
    LoaderApp
  },
  data() {
    return {
      articulo: new Articulo(
        null,
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        5
      ),
      loading: true,
      loadingActividad: false,
      actividades: [],
      actividadPaginacion: null
    };
  },
  mounted() {
    this.articulo.id = this.$route.params.id;
    this.getArticulo();
  },
  methods: {
    getArticulo() {
      this.loading = true;
      axios
        .get("/articulos/" + this.articulo.id)
        .then(res => {
          if (res.data.success) {
            this.articulo = res.data.articulo;
            this.getActividad();
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getActividad(page = 1) {
      this.loadingActividad = true;
      axios
        .get("/actividad-articulos/" + this.articulo.id + "?page=" + page)
        .then(res => {
          this.actividades = res.data.data;
          this.actividadPaginacion = {
            current_page: res.data.current_page,
            last_page: res.data.last_page
          };
        })
        .catch(() => {})
        .finally(() => {
          this.loadingActividad = false;
        });
    },
    badgeClass(act) {
      const ctx = (act.contexto || '').toLowerCase();
      if (ctx.includes('venta') || ctx.includes('pedido nuevo')) return 'badge-primary';
      if (ctx.includes('nota de crédito') || ctx.includes('anulado')) return 'badge-warning';
      if (ctx.includes('eliminado') || ctx.includes('reposición')) return 'badge-info';
      if (ctx.includes('edición manual')) return 'badge-secondary';
      return 'badge-light';
    },
    eliminarArticulo() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${this.articulo.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/articulos/" + this.articulo.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.articulo.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              this.$router.push({ name: "ListarArticulos" });
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>